import { CommonModule } from '@angular/common';
import {
    Component,
    OnInit,
    input,
    ChangeDetectionStrategy,
} from '@angular/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { Apollo, QueryRef } from 'apollo-angular';
import { Observable, map, tap } from 'rxjs';
import { GetProductHistoryQuery } from 'src/__generated__/graphql';
import { ProductQueries } from 'src/app/services/graphql/product-queries';

@Component({
    selector: 'app-product-history',
    templateUrl: './product-history.component.html',
    styleUrls: ['./product-history.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatTableModule, MatPaginatorModule, CommonModule],
})
export class ProductHistoryComponent implements OnInit {
    productHistoryQuery?: QueryRef<GetProductHistoryQuery>;
    totalCount = 0;
    pageIndex = 0;
    pageSize = 25;
    public productHistory!: Observable<any[]>;
    readonly productId = input('');
    displayedColumns: string[] = [
        'validFrom',
        'providerId',
        'price',
        'overridePriceAmount',
        'cost',
        'value',
        'title',
        'description',
        'enabled',
        'providerRemoved',
        'note',
    ];
    constructor(private apollo: Apollo) {}

    ngOnInit(): void {
        this.productHistoryQuery =
            this.apollo.watchQuery<GetProductHistoryQuery>({
                query: ProductQueries.PRODUCTHISTORY,
                variables: this.getFilter(),
            });
        this.productHistory = this.productHistoryQuery.valueChanges
            .pipe(
                tap(
                    ({ data }) =>
                        (this.totalCount =
                            data?.marketplaceProductHistorySearch?.totalCount ??
                            0),
                ),
            )
            .pipe(
                map(
                    ({ data }) =>
                        data?.marketplaceProductHistorySearch?.items ?? [],
                ),
            );
    }
    buildDataSource(): void {
        this.productHistoryQuery?.refetch(this.getFilter());
    }
    onPage(evt: any): void {
        this.pageIndex = evt.pageIndex;
        this.pageSize = evt.pageSize;
        this.buildDataSource();
    }
    getFilter(): any {
        return {
            productId: this.productId(),
            pagination: {
                take: this.pageSize,
                skip: this.pageIndex * this.pageSize,
            },
        };
    }
}
